export default __webpack_public_path__ + "static/media/02.2.108e076e.webp";